import type { TagTone, TagVariant } from './types';

// tone → { soft, solid } 매핑 (텍스트/배경 클래스)
export const TAG_TONE_THEME: Record<TagTone, Record<TagVariant, { text: string; bg: string }>> = {
  lightGray: {
    soft: { text: 'text-system-gray-700', bg: 'bg-system-gray-100' },
    solid: { text: 'text-system-gray-700', bg: 'bg-system-gray-100' },
  },
  mint: {
    soft: { text: 'text-brand-tertiary', bg: 'bg-system-mint-light' },
    solid: { text: 'text-white', bg: 'bg-system-mint' },
  },
  red: {
    soft: { text: 'text-system-red1', bg: 'bg-system-red-light' },
    solid: { text: 'text-white', bg: 'bg-system-red1' },
  },
  yellow: {
    soft: { text: 'text-system-yellow', bg: 'bg-system-yellow-light' },
    solid: { text: 'text-system-black', bg: 'bg-system-yellow' },
  },
  blue: {
    soft: { text: 'text-system-blue', bg: 'bg-system-blue-light' },
    solid: { text: 'text-white', bg: 'bg-system-blue' },
  },
  gray: {
    soft: { text: 'text-system-gray-700', bg: 'bg-system-gray-300' },
    solid: { text: 'text-white', bg: 'bg-system-gray-700' },
  },
  green: {
    soft: { text: 'text-brand-tertiary', bg: 'bg-[#E6F9E6]' },
    solid: { text: 'text-white', bg: 'bg-system-green' },
  },

  purple: {
    soft: { text: 'text-system-purple2', bg: 'bg-[#F0E5FF]' },
    solid: { text: 'text-white', bg: 'bg-system-purple2' },
  },
  black: {
    soft: { text: 'text-white', bg: 'bg-system-gray-900' },
    solid: { text: 'text-white', bg: 'bg-system-gray-900' },
  },
  emphasis: {
    // ✅ soft: 배경은 연한 그라데이션, 글씨는 보통 검정/회색(가독성)
    soft: { text: 'text-system-black', bg: 'bg-tag-emphasis-soft' },
    // ✅ solid: 배경은 진한 그라데이션, 글씨는 흰색
    solid: { text: 'text-white', bg: 'bg-tag-emphasis' },
  },
};
